import { ChakraProvider, Grid, theme } from "@chakra-ui/react";
import Router from "./routes";
import { GlobalContextProvider } from "./contexts/Globals";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const App = () => (
  <ChakraProvider theme={theme}>
    <GlobalContextProvider>
      <Grid minH="100vh">
        <Router />
        <ToastContainer />
      </Grid>
    </GlobalContextProvider>
  </ChakraProvider>
);
